<template>
  <div class="footer__terms">
    <p>
      Finance Magnates Group is the leading source for financial news, events,
      analysis, and research. The group includes several marquee brands, each
      servicing a different niche in the financial services industry. Copyright
      © {{ currentYear }} "Finance Magnates CY Ltd." All rights reserved. For
      more information, read our
      <a-link class="footer__terms-link" :to="linkToTermsOfUse">Terms,</a-link>
      <a-link class="footer__terms-link" :to="linkToCookies">Cookies</a-link>
      and
      <a-link class="footer__terms-link" :to="linkToPrivacyPolicy">
        Privacy Notice</a-link
      >.
      <a
        href="#"
        class="footer__manage-cookies-link"
        @click.prevent="$_oneTrust_toggleCookiePreferencesPopup"
        >Manage Cookies</a
      >
    </p>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'FooterTerms',
  mixins: [mixins.oneTrust],
  data() {
    const domain = this.$helper.removeEndingSlashes(this.$env.FM_DOMAIN_URL)

    return {
      ROUTE_NAME,
      currentYear: new Date().getFullYear(),
      linkToTermsOfUse: `${domain}/terms-of-use/`,
      linkToCookies: `${domain}/cookies/`,
      linkToPrivacyPolicy: `${domain}/privacy/`
    }
  }
}
</script>

<style lang="scss" scoped>
.footer__terms {
  line-height: 1.25;
  margin-top: 40px;
  max-width: 1250px;
  font-weight: 300;

  & * {
    color: $c--gray-footer-text;
  }

  & a:hover {
    color: black;
  }

  $margin-top: (
    $above-desktop-xl: 40px,
    $desktop-sm: 25px,
    $mobile: 30px
  );

  $font-size: (
    $above-desktop-xl: 16px,
    $desktop-sm: 14px,
    $tablet: 10px
  );

  @include setStyleByBreakpoint('margin-top', $margin-top);
  @include setStyleByBreakpoint('font-size', $font-size);
}

.footer__terms-link,
.footer__manage-cookies-link {
  text-decoration: underline;
}
</style>
